const titleSize = {
  xxs: 'xsmall',
};
const descriptionProps = {
  heading: 'Product description',
  headingTag: 'h2',
  dataTestId: 'description-accordion',
  titleSize,
};
const featuresProps = {
  heading: 'Product features',
  headingTag: 'h2',
  dataTestId: 'features-accordion',
  titleSize,
};
const techSpecsProps = {
  heading: 'Technical specification',
  headingTag: 'h2',
  dataTestId: 'tech-specs-accordion',
  titleSize,
};
const documentationProps = {
  heading: 'Additional information',
  headingTag: 'h2',
  dataTestId: 'documentation-accordion',
  titleSize,
};
const accordionsProps = {
  descriptionProps,
  featuresProps,
  techSpecsProps,
  documentationProps,
};

export default accordionsProps;
